import React, { useState } from "react";
import { Container } from "react-bootstrap";
import img1 from "../../assets/Images/Blogs/Gemini_Generated_Image_qryfzjqryfzjqryf.jpg";
import img2 from "../../assets/Images/Blogs/Gemini_Generated_Image_pkg512pkg512pkg5.jpg";
import img3 from "../../assets/Images/Blogs/Gemini_Generated_Image_akwtnwakwtnwakwt.jpg";
import img4 from "../../assets/Images/Blogs/Gemini_Generated_Image_4iqaeb4iqaeb4iqa.jpg";
import img5 from "../../assets/Images/Blogs/Gemini_Generated_Image_rxig8vrxig8vrxig.jpg";
import img6 from "../../assets/Images/Blogs/Gemini_Generated_Image_xvcrehxvcrehxvcr.jpg";
import img7 from "../../assets/Images/Blogs/Gemini_Generated_Image_rzy7b4rzy7b4rzy7.jpg";
import img8 from "../../assets/Images/Blogs/Gemini_Generated_Image_65r1dy65r1dy65r1.jpg";
import img9 from "../../assets/Images/Blogs/Gemini_Generated_Image_u765nku765nku765.jpg";
import img10 from "../../assets/Images/Blogs/Gemini_Generated_Image_cktmbmcktmbmcktm.jpg";
import img11 from "../../assets/Images/Blogs/Gemini_Generated_Image_2fbeo02fbeo02fbe.jpg";
import { useIsMobile } from "../../utils/responsive";

export default function Section5() {
  const [hoveredImage, setHoveredImage] = useState(null);

  const isMobile = useIsMobile();

  const handleImageHover = (index) => {
    setHoveredImage(index);
  };

  const sectionData = [
    {
      title: "1. FLAMINGO PINK, AQUAMARINE GREEN",
      content:
        "This contrasting scheme pits a pale aquamarine against a flamingo hued pink.Accessorized with a splash of rich fuschia pink on the mirror frame, the pale blue flooring gives it an air of a modern classic.",
      image: img1,
      imageIndex: 1,
    },
    {
      title: "2. BLUE HUES",
      content:
        "Using variations of one color is a calming approach.Deep blue hue of the chest of drawers makes a sophisticated backdrop to the lighter tinted powder blues of the upholstery.The teal bowl adds an additional layer of color.",
      image: img2,
      imageIndex: 2,
    },
    {
      title: "3. PLUM, PINK, AUBERGINE",
      content:
        "This harmonious scheme utilizes a host of pink and purple shades to great effect.Rich aubergine upholstery is echoed by the lampshade, while plum walls add warmth.Small splashes of pink and yellow lift the scheme from becoming too moody.",
      image: img3,
      imageIndex: 3,
    },
    {
      title: "4. JADE GREEN, PETROL BLUE",
      content:
        "Green ranges from watery blues to deep forest greens, reflecting the world around us.This palette creates a strong, yet warm and livable statement.Plain colors and welcoming patterns provide a perfect foundation.",
      image: img4,
      imageIndex: 4,
    },
    {
      title: "5. GRAY GREEN, RED",
      content:
        "A split complementary scheme, chosen from adjacent points on the color wheel.Deep green paint with gray undertones pairs with vivid reds and corals.",
      image: img5,
      imageIndex: 5,
    },
    {
      title: "6. TERRACOTTA, BLUE",
      content:
        "Terracotta wall provides a warm background for a bold royal blue sofa.Matching blue footstool and paler rug anchor the look.Dashes of brown, pink, and terracotta on cushions and artwork tie it all together.",
      image: img6,
      imageIndex: 6,
    },
    {
      title: "7. FRESH GREENS",
      content:
        "Multiple green hues in pattern, planting and upholstery are harmonized with blue.Black lines and pale cream walls frame and ground the look.",
      image: img7,
      imageIndex: 7,
    },
    {
      title: "8. FUSCHIA PINK, CORAL, PEACOCK BLUE, FOREST GREEN",
      content:
        "Rich pink bedspread is the dramatic focal point.Split complementary scheme includes deep blue headboard and forest green walls for a cohesive, cozy sophistication.",
      image: img8,
      imageIndex: 8,
    },
    {
      title: "9. DUCK EGG, RED",
      content:
        "Complementary hues of vibrant red and cool duck egg create a fresh mix.Geometric monochrome pattern adds a modern edge, softened by curved furniture.",
      image: img9,
      imageIndex: 9,
    },
    {
      title: "10. BLUE, OLIVE GREEN, SUNSHINE YELLOW",
      content:
        "Colors from a third of the wheel—blue, yellow, and olive green—create a calming effect.Neutral patterned wallpaper grounds the look.Pale green pattern on headboard adds freshness.",
      image: img10,
      imageIndex: 10,
    },
    {
      title: "11. DELICATE PINKS",
      content:
        "Powder pink walls and upholstery are enhanced by accessories.Rich pink curtains and a patterned rug in various pink hues tie the look together.",
      image: img11,
      imageIndex: 11,
    },
  ];

  return (
    <Container fluid className="p-0">
      {/* Header Row */}
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              borderRight: "1px solid black",
              // borderLeft: "1px solid black",
            }}
          ></div>
        )}
        <div
          style={{
            width: isMobile ? "100%" : "90%",
            // borderTop: "1px solid black",
            borderBottom: "1px solid black",
            // borderRight: "1px solid black",
            // borderLeft: "1px solid black",
          }}
        >
          <div
            style={{
              padding: "20px 40px",
            }}
          >
            <h3 className="heading-sm m-0">COLOR WHEEL-INSPIRED SCHEMES</h3>
          </div>
        </div>

        {!isMobile && (
          <div
            style={{
              width: "5%",
              // borderTop: "1px solid black",
              borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              borderLeft: "1px solid black",
            }}
          ></div>
        )}
      </div>
      {!isMobile && (
        <>
          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: "20px 40px",
                }}
              >
                <h3 className="heading-sm m-0">
                  1. FLAMINGO PINK, AQUAMARINE GREEN
                </h3>
              </div>
            </div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: "20px 40px",
                }}
              >
                <h3 className="heading-sm m-0">2. BLUE HUES</h3>
              </div>
            </div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>
          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: "20px 40px",
                }}
              >
                <p className="body-lg m-0">
                  This contrasting scheme pits a pale aquamarine against a
                  flamingo hued pink. Accessorized with a splash of rich fuschia
                  pink on the mirror frame, the pale blue flooring gives it an
                  air of a modern classic.
                </p>
              </div>
            </div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: "20px 40px",
                }}
              >
                <p className="body-lg m-0">
                  Using variations of one color is a calming approach. Here, the
                  deep blue hue of the chest of drawers makes a sophisticated
                  backdrop to the lighter tinted powder blues of the upholstery,
                  while the teal bowl adds an additional layer of color.
                </p>
              </div>
            </div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>
          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div
                style={{
                  height: "100%",
                  overflow: "hidden",
                }}
                onMouseEnter={() => handleImageHover(1)}
                onMouseLeave={() => handleImageHover(null)}
              >
                <img
                  src={img1}
                  alt="Profile 1"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    maxHeight: "400px",
                    transition: "all 0.5s ease",
                    transform: hoveredImage === 1 ? "scale(1.05)" : "scale(1)",
                    filter:
                      hoveredImage === 1 ? "brightness(1.05)" : "brightness(1)",
                  }}
                />
              </div>
            </div>
            <div
              style={{
                width: "45%",
                borderTop: "1px solid black",
                borderBottom: "1px solid black",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div
                style={{
                  height: "100%",
                  overflow: "hidden",
                }}
                onMouseEnter={() => handleImageHover(2)}
                onMouseLeave={() => handleImageHover(null)}
              >
                <img
                  src={img2}
                  alt="Profile 1"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    maxHeight: "400px",
                    transition: "all 0.5s ease",
                    transform: hoveredImage === 2 ? "scale(1.05)" : "scale(1)",
                    filter:
                      hoveredImage === 2 ? "brightness(1.05)" : "brightness(1)",
                  }}
                />
              </div>
            </div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>

          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: "20px 40px",
                }}
              >
                <h3 className="heading-sm m-0">3. PLUM, PINK, AUBERGINE</h3>
              </div>
            </div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: "20px 40px",
                }}
              >
                <h3 className="heading-sm m-0">4. JADE GREEN, PETROL BLUE</h3>
              </div>
            </div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>
          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: "20px 40px",
                }}
              >
                <p className="body-lg m-0">
                  This harmonious scheme utilises a host of pink and purple
                  shades to great effect. The rich aubergine color of the
                  upholstery is echoed by the lampshade, while the plum walls
                  wrap the scheme in warmth. Small splashes of pink and yellow
                  lift the scheme from becoming too moody.
                </p>
              </div>
            </div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: "20px 40px",
                }}
              >
                <p className="body-lg m-0">
                  Green is on the cooler side of the color wheel, ranging from
                  watery blues to deep forest greens, reflecting the world
                  around us – sky, sea and earth. This palette can create a
                  visually strong statement that is also warm and very easy to
                  live with. A pleasing plain color paired with a welcoming
                  pattern, is the perfect foundation for an inviting room
                  scheme.
                </p>
              </div>
            </div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>
          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div
                style={{
                  height: "100%",
                  overflow: "hidden",
                }}
                onMouseEnter={() => handleImageHover(3)}
                onMouseLeave={() => handleImageHover(null)}
              >
                <img
                  src={img3}
                  alt="Profile 1"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    maxHeight: "400px",
                    transition: "all 0.5s ease",
                    transform: hoveredImage === 3 ? "scale(1.05)" : "scale(1)",
                    filter:
                      hoveredImage === 3 ? "brightness(1.05)" : "brightness(1)",
                  }}
                />
              </div>
            </div>
            <div
              style={{
                width: "45%",
                borderTop: "1px solid black",
                borderBottom: "1px solid black",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div
                style={{
                  height: "100%",
                  overflow: "hidden",
                }}
                onMouseEnter={() => handleImageHover(4)}
                onMouseLeave={() => handleImageHover(null)}
              >
                <img
                  src={img4}
                  alt="Profile 1"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    maxHeight: "400px",
                    transition: "all 0.5s ease",
                    transform: hoveredImage === 4 ? "scale(1.05)" : "scale(1)",
                    filter:
                      hoveredImage === 4 ? "brightness(1.05)" : "brightness(1)",
                  }}
                />
              </div>
            </div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>

          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: "20px 40px",
                }}
              >
                <h3 className="heading-sm m-0">5. GRAY GREEN, RED</h3>
              </div>
            </div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: "20px 40px",
                }}
              >
                <h3 className="heading-sm m-0">6. TERRACOTTA, BLUE</h3>
              </div>
            </div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>
          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: "20px 40px",
                }}
              >
                <p className="body-lg m-0">
                  A split complementary scheme, chosen from adjacent points on
                  the color wheel. The deep green paint on the walls features
                  deep gray undertones making a striking backdrop for a cast of
                  vivid furnishings and accessories in appealing shades of red
                  and coral.
                </p>
              </div>
            </div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: "20px 40px",
                }}
              >
                <p className="body-lg m-0">
                  In this living space, the tonal shade of terracotta on the
                  wall provides a warm background for the bold royal blue sofa.
                  Dashes of brown, terracotta and pink on cushions and artworks
                  echo the wall colors, while the matching blue footstool and
                  paler blue rug anchor the look.
                </p>
              </div>
            </div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>
          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div
                style={{
                  height: "100%",
                  overflow: "hidden",
                }}
                onMouseEnter={() => handleImageHover(5)}
                onMouseLeave={() => handleImageHover(null)}
              >
                <img
                  src={img5}
                  alt="Profile 1"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    maxHeight: "400px",
                    transition: "all 0.5s ease",
                    transform: hoveredImage === 5 ? "scale(1.05)" : "scale(1)",
                    filter:
                      hoveredImage === 5 ? "brightness(1.05)" : "brightness(1)",
                  }}
                />
              </div>
            </div>
            <div
              style={{
                width: "45%",
                borderTop: "1px solid black",
                borderBottom: "1px solid black",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div
                style={{
                  height: "100%",
                  overflow: "hidden",
                }}
                onMouseEnter={() => handleImageHover(6)}
                onMouseLeave={() => handleImageHover(null)}
              >
                <img
                  src={img6}
                  alt="Profile 1"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    maxHeight: "400px",
                    transition: "all 0.5s ease",
                    transform: hoveredImage === 6 ? "scale(1.05)" : "scale(1)",
                    filter:
                      hoveredImage === 6 ? "brightness(1.05)" : "brightness(1)",
                  }}
                />
              </div>
            </div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>

          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: "20px 40px",
                }}
              >
                <h3 className="heading-sm m-0">7. FRESH GREENS</h3>
              </div>
            </div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: "20px 40px",
                }}
              >
                <h3 className="heading-sm m-0">
                  8. FUSCHIA PINK, CORAL, PEACOCK BLUE, FOREST GREEN
                </h3>
              </div>
            </div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>
          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: "20px 40px",
                }}
              >
                <p className="body-lg m-0">
                  A clutch of green hues are combined in pattern, planting and
                  upholstery, with a harmonious pop of blue. All are framed and
                  grounded with strong black lines and pale cream walls.
                </p>
              </div>
            </div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: "20px 40px",
                }}
              >
                <p className="body-lg m-0">
                  The rich, pink of the sumptuous bedspread is the dramatic
                  focus of this bedroom. A classic split complementary scheme,
                  the addition of the deep blue shade of the headboard and the
                  forest green walls ensure a cohesive, cosy sophistication.
                </p>
              </div>
            </div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>
          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div
                style={{
                  height: "100%",
                  overflow: "hidden",
                }}
                onMouseEnter={() => handleImageHover(7)}
                onMouseLeave={() => handleImageHover(null)}
              >
                <img
                  src={img7}
                  alt="Profile 1"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    maxHeight: "400px",
                    transition: "all 0.5s ease",
                    transform: hoveredImage === 7 ? "scale(1.05)" : "scale(1)",
                    filter:
                      hoveredImage === 7 ? "brightness(1.05)" : "brightness(1)",
                  }}
                />
              </div>
            </div>
            <div
              style={{
                width: "45%",
                borderTop: "1px solid black",
                borderBottom: "1px solid black",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div
                style={{
                  height: "100%",
                  overflow: "hidden",
                }}
                onMouseEnter={() => handleImageHover(8)}
                onMouseLeave={() => handleImageHover(null)}
              >
                <img
                  src={img8}
                  alt="Profile 1"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    maxHeight: "400px",
                    transition: "all 0.5s ease",
                    transform: hoveredImage === 8 ? "scale(1.05)" : "scale(1)",
                    filter:
                      hoveredImage === 8 ? "brightness(1.05)" : "brightness(1)",
                  }}
                />
              </div>
            </div>
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>

          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: "20px 40px",
                }}
              >
                <h3 className="heading-sm m-0">9. DUCK EGG, RED</h3>
              </div>
            </div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: "20px 40px",
                }}
              >
                <h3 className="heading-sm m-0">
                  10. BLUE, OLIVE GREEN, SUNSHINE YELLOW
                </h3>
              </div>
            </div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>
          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: "20px 40px",
                }}
              >
                <p className="body-lg m-0">
                  Complementary hues of vibrant red and cool duck egg prove a
                  surprisingly fresh mix, against which geometric pattern in
                  crisp monochrome lends a modern edge. The look is softened by
                  the curves of the dining table and chairs.
                </p>
              </div>
            </div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: "20px 40px",
                }}
              >
                <p className="body-lg m-0">
                  Utilising colors from almost a third of the wheel, this
                  harmonious scheme teams blocks of blue, yellow and olive green
                  together for a calming effect. Patterned wallpaper in a
                  neutral shade grounds the look, while the pale green pattern
                  on the headboard gives it a fresh edge.
                </p>
              </div>
            </div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>
          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div
                style={{
                  height: "100%",
                  overflow: "hidden",
                }}
                onMouseEnter={() => handleImageHover(9)}
                onMouseLeave={() => handleImageHover(null)}
              >
                <img
                  src={img9}
                  alt="Profile 1"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    maxHeight: "400px",
                    transition: "all 0.5s ease",
                    transform: hoveredImage === 9 ? "scale(1.05)" : "scale(1)",
                    filter:
                      hoveredImage === 9 ? "brightness(1.05)" : "brightness(1)",
                  }}
                />
              </div>
            </div>
            <div
              style={{
                width: "45%",
                borderTop: "1px solid black",
                borderBottom: "1px solid black",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div
                style={{
                  height: "100%",
                  overflow: "hidden",
                }}
                onMouseEnter={() => handleImageHover(10)}
                onMouseLeave={() => handleImageHover(null)}
              >
                <img
                  src={img10}
                  alt="Profile 1"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    maxHeight: "400px",
                    transition: "all 0.5s ease",
                    transform: hoveredImage === 10 ? "scale(1.05)" : "scale(1)",
                    filter:
                      hoveredImage === 10
                        ? "brightness(1.05)"
                        : "brightness(1)",
                  }}
                />
              </div>
            </div>
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>

          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: "20px 40px",
                }}
              >
                <h3 className="heading-sm m-0">11. DELICATE PINKS</h3>
              </div>
            </div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>
          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            >
              <div
                style={{
                  padding: "20px 40px",
                }}
              >
                <p className="body-lg m-0">
                  Powder pink walls and upholstery are given extra depth thanks
                  to the accessories in this space. Rich pink curtains and a
                  patterned rug in a plethora of pink hues, from pale pinks to
                  almost red shades tie the tonal look together beautifully.
                </p>
              </div>
            </div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>
          <div className="d-flex justify-content-center">
            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                // borderBottom: "1px solid black",
                borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>
            <div
              style={{
                width: "45%",
                borderTop: "1px solid black",
                borderBottom: "1px solid black",
                borderRight: "1px solid black",
                overflow: "hidden",
                position: "relative",
              }}
            >
              <div
                style={{
                  height: "100%",
                  overflow: "hidden",
                }}
                onMouseEnter={() => handleImageHover(11)}
                onMouseLeave={() => handleImageHover(null)}
              >
                <img
                  src={img11}
                  alt="Profile 1"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    maxHeight: "400px",
                    transition: "all 0.5s ease",
                    transform: hoveredImage === 11 ? "scale(1.05)" : "scale(1)",
                    filter:
                      hoveredImage === 11
                        ? "brightness(1.05)"
                        : "brightness(1)",
                  }}
                />
              </div>
            </div>
            <div
              style={{
                width: "45%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                // borderLeft: "1px solid black",
              }}
            ></div>

            <div
              style={{
                width: "5%",
                // borderTop: "1px solid black",
                borderBottom: "1px solid black",
                // borderRight: "1px solid black",
                borderLeft: "1px solid black",
              }}
            ></div>
          </div>
        </>
      )}

      {isMobile &&
        sectionData.map((section, index) => (
          <div key={index}>
            <div
              style={{
                padding: isMobile ? "20px 40px" : "40px 40px",
                borderBottom: "1px solid black",
              }}
            >
              <h3 className="heading-sm m-0">{section.title}</h3>
            </div>
            <div
              style={{
                padding: "20px 40px",
                borderBottom: "1px solid black",
              }}
            >
              <p className="body-lg m-0">{section.content}</p>
            </div>
            <div
              className="image-container"
              style={{
                height: "100%",
                minHeight: "400px",
                display: "flex",
                flexDirection: "row",
                gap: "0",
                transition: "all 0.5s ease",
                borderBottom: "1px solid black",
              }}
              onMouseEnter={() => handleImageHover(section.imageIndex)}
              onMouseLeave={() => handleImageHover(null)}
            >
              <img
                src={section.image}
                alt="Profile 1"
                className="image-cover-full-responsive"
                style={{
                  transition: "all 0.5s ease",
                  transform:
                    hoveredImage === section.imageIndex
                      ? "scale(1.05)"
                      : "scale(1)",
                  filter:
                    hoveredImage === section.imageIndex
                      ? "brightness(1.05)"
                      : "brightness(1)",
                }}
              />
            </div>
          </div>
        ))}
    </Container>
  );
}
